export default __webpack_public_path__ + "static/media/04.290fe053.jpg";